import React, { useState } from "react";
import axios from "axios";
import CreateDevisForm from "../../component/CreateDevisVisitor";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function CreateDevisPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;

  const [data, setData] = useState({
    activitySector: "",
    company: "",
    SIRET: "",
    SIREN: "",
    servicesDemandes: [], // tableau
    budgetEstime: 0,
    currency: "EUR",
    description: "",
    dateSoumission: "",
    statut: "En cours",
    KBIS: null,
    pieceJointe: null, // Ajout de pieceJointe
  });

  const [pdf, setPdf] = useState(null);
  const [pieceJointe, setPieceJointe] = useState(null); // Ajout de l'état pour PieceJointe
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCheckError, setShowCheckError] = useState(false);

  const [formData, setFormData] = useState();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Mise à jour pour gérer les deux fichiers
 const handleFileChange = (e) => {
   const { name, files } = e.target;
   const file = files[0];

   if (name === "KBIS") {
     setPdf(file); // c'est le fichier KBIS
   } else if (name === "pieceJointe") {
     setPieceJointe(file); // c'est le fichier pièce jointe
   }
 };

  const resetForm = () => {
    setData({
      activitySector: "",
      company: "",
      SIRET: "",
      SIREN: "",
      servicesDemandes: [],
      budgetEstime: 0,
      currency: "EUR",
      description: "",
      dateSoumission: "",
      statut: "En cours",
    });
    setPdf(null);
    setPieceJointe(null); // Réinitialiser les fichiers
    setIsChecked(false);
    setErrors({});
    setShowCheckError(false);
  };

  const handleCreateDevis = async () => {
    if (!userId) {
      toast.error("Utilisateur non trouvé. Veuillez vous inscrire d'abord.");
      return;
    }

    if (!pdf) {
      toast.error("Veuillez télécharger le fichier KBIS.");
      return;
    }

    const formData = new FormData();
    formData.append("clientId", userId);
    formData.append("activitySector", data.activitySector);
    formData.append("company", data.company);
    formData.append("servicesDemandes", JSON.stringify(data.servicesDemandes));
    formData.append("budgetEstime", data.budgetEstime);
    formData.append("currency", data.currency);
    formData.append("description", data.description);
    formData.append("dateSoumission", data.dateSoumission);
    formData.append("statut", data.statut);

    formData.append("SIRET", data.SIRET);

    formData.append("SIREN", data.SIREN);
    // Ajouter les fichiers
    if (pdf) {
      formData.append("KBIS", pdf);
    }

    if (pieceJointe) {
      formData.append("pieceJointe", pieceJointe); // Ajouter pieceJointe si sélectionné
    }

    try {
      setIsLoading(true);
      const result = await axios.post("/devis/createdevisvisitor", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Devis enregistré avec succès !");
      resetForm();
      navigate("/success");
    } catch (error) {
      toast.error("Erreur lors de la création du devis");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CreateDevisForm
      isLoading={isLoading}
      data={data}
      handleInputChange={handleInputChange}
      handleFileChange={handleFileChange}
      pdf={pdf}
      pieceJointe={pieceJointe} // Passer la pieceJointe
      errors={errors}
      isChecked={isChecked}
      setIsChecked={setIsChecked}
      showCheckError={showCheckError}
      onSubmit={handleCreateDevis}
    />
  );
}

export default CreateDevisPage;
